import React from 'react';
// Removed motion, AnimatePresence, specific icons if not used directly in App.tsx layout
// UI components like Button, Input, etc., are now used within specific pages/components, not directly in App.tsx

// Import routing components
import { Routes, Route, Outlet } from 'react-router-dom';

// Import contexts and auth
// import { useAuth } from './contexts/AuthContext'; // Removed as NavBar and ProtectedRoute now use this directly

// Import components
import NavBar from './components/NavBar'; // Default import
import ProtectedRoute from './components/ProtectedRoute';

// Import page components
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductPage';
import AboutUsPage from './pages/AboutUsPage';
import ContactUsPage from './pages/ContactUsPage';
import LoginPage from './pages/LoginPage';
import AdminPanelPage from './pages/admin/AdminPanelPage';
// import NotFoundPage from './pages/NotFoundPage'; // Example for a 404 page

// Mock Data, Product interface, and formatCurrency are removed as pages now fetch their own data
// or these would be centralized if still needed by multiple components.


// AppLayout component to provide consistent structure
const AppLayout = () => {
  // const { isAuthenticated } = useAuth(); // NavBar now handles its own auth display logic
  return (
    <div className="app-container">
      <NavBar /> {/* NavBar no longer needs isAuthenticated or onLogout passed as props */}
      <main className="app-main">
        <Outlet /> {/* Nested routes will render here */}
      </main>
      <footer className="app-footer">
        &copy; {new Date().getFullYear()} Venus HVAC Supplies. All rights reserved.
      </footer>
    </div>
  );
};

const App = () => {
  // const { isLoading } = useAuth(); // isLoading is used by ProtectedRoute

  // if (isLoading) { // This check could be here or handled by individual routes/ProtectedRoute
  //   return <div>Loading application...</div>;
  // }

  return (
    <Routes>
      <Route path="/" element={<AppLayout />}>
        {/* Public Routes */}
        <Route index element={<HomePage />} /> {/* No longer pass MOCK_PRODUCTS */}
        <Route path="products" element={<ProductsPage />} /> {/* No longer pass MOCK_PRODUCTS */}
        <Route path="about" element={<AboutUsPage />} />
        <Route path="contact" element={<ContactUsPage />} />
        <Route path="login" element={<LoginPage />} />

        {/* Cart and Profile routes - placeholder, might need components and protection */}
        <Route path="cart" element={<div>Shopping Cart Page (Placeholder)</div>} />
        <Route path="profile" element={<div>User Profile Page (Placeholder)</div>} />

        {/* Protected Admin Route */}
        <Route path="admin" element={<ProtectedRoute />}>
          <Route index element={<AdminPanelPage />} />
          {/* Example for future nested admin routes: */}
          {/* <Route path="users" element={<AdminUsersPage />} /> */}
          {/* <Route path="settings" element={<AdminSettingsPage />} /> */}
        </Route>

        {/* Fallback for 404 Not Found */}
        <Route path="*" element={
          <div>
            <h2>404 - Page Not Found</h2>
            <p>Sorry, the page you are looking for does not exist.</p>
          </div>
        } />
      </Route>
    </Routes>
  );
};

export default App;
